import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class CLProfessionalCatService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/CLProfessionalCats`);
    }
}